(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["BuscaTuEquipo"] && !Shopify.designMode) return;
  try {
    
(function () {
  function handleize(s) { return (s || '').toString().toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
  function findPill(key) {
    if (!key) return null;
    var pills = document.querySelectorAll('.ld-productos__pill[data-filtro-equipo]');
    var i, v;
    for (i = 0; i < pills.length; i++) { if (pills[i].getAttribute('data-filtro-equipo') === key) return pills[i]; }
    for (i = 0; i < pills.length; i++) { v = pills[i].getAttribute('data-filtro-equipo'); if (v && v.length > key.length && v.slice(-(key.length + 1)) === ('-' + key)) return pills[i]; }
    return null;
  }
  function goToTeam(card) {
    var key = card.getAttribute('data-filtro');
    var pill = findPill(key);
    var target = null;
    if (pill) { pill.click(); target = pill.closest('.shopify-section') || pill; }
    else { var grid = document.querySelector('[id^="ld-grid-"]'); if (grid) target = grid.closest('.shopify-section') || grid; }
    if (target) { var y = target.getBoundingClientRect().top + window.pageYOffset - 16; window.scrollTo({ top: y, behavior: 'smooth' }); }
  }
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var card = e.target.closest('.bte-card');
    if (card) { e.preventDefault(); goToTeam(card); return; }
    var arrow = e.target.closest('.bte-arrow');
    if (arrow) {
      var carr = arrow.closest('.bte-carrusel'); if (!carr) return;
      var track = carr.querySelector('.bte-track'); if (!track) return;
      var amount = Math.round(track.clientWidth * 0.85);
      track.scrollBy({ left: arrow.classList.contains('bte-arrow--prev') ? -amount : amount, behavior: 'smooth' });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["HeaderIcons"]) return;
  try {
    
(function () {
  function escapeHtml(x){ return (x==null?'':String(x)).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];}); }
  function onInput(input){
    var wrap = input.closest('[data-hdr-search]'); if(!wrap) return;
    var box = wrap.querySelector('[data-hdr-results]');
    var q = input.value.trim();
    clearTimeout(input.__t);
    if(q.length < 2){ box.hidden = true; box.innerHTML=''; return; }
    input.__t = setTimeout(function(){
      var base = wrap.getAttribute('data-search-url') || '/search';
      var url = base + '/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url).then(function(r){ return r.json(); }).then(function(d){
        var items = (d.resources && d.resources.results && d.resources.results.products) || [];
        if(!items.length){ box.innerHTML = '<div class="hdr__pred-empty">Sin resultados para "' + escapeHtml(q) + '"</div>'; box.hidden = false; return; }
        var html = '';
        items.forEach(function(p){
          var img = p.image || (p.featured_image && p.featured_image.url) || '';
          html += '<a class="hdr__pred-item" href="' + p.url + '">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '<span class="hdr__pred-noimg"></span>') + '<span class="hdr__pred-title">' + escapeHtml(p.title) + '</span></a>';
        });
        box.innerHTML = html; box.hidden = false;
      }).catch(function(){ box.hidden = true; });
    }, 220);
  }
  document.addEventListener('input', function(e){ if(e.target && e.target.matches && e.target.matches('[data-hdr-input]')) onInput(e.target); });
  document.addEventListener('click', function(e){
    var burger = e.target.closest && e.target.closest('[data-hdr-burger]');
    if(burger){ var hdr = burger.closest('.hdr'); var m = hdr && hdr.querySelector('[data-hdr-mobile]'); if(m){ var open = m.classList.toggle('is-open'); burger.setAttribute('aria-expanded', open ? 'true':'false'); } return; }
    var mt = e.target.closest && e.target.closest('[data-hdr-mtoggle]');
    if(mt){ mt.parentElement.classList.toggle('is-open'); return; }
    if(!(e.target.closest && e.target.closest('[data-hdr-search]'))){ document.querySelectorAll('[data-hdr-results]').forEach(function(b){ b.hidden = true; }); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["HeaderIconsWhite"]) return;
  try {
    
(function () {
  function escapeHtml(x){ return (x==null?'':String(x)).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];}); }
  function onInput(input){
    var wrap = input.closest('[data-hdr-search]'); if(!wrap) return;
    var box = wrap.querySelector('[data-hdr-results]');
    var q = input.value.trim();
    clearTimeout(input.__t);
    if(q.length < 2){ box.hidden = true; box.innerHTML=''; return; }
    input.__t = setTimeout(function(){
      var base = wrap.getAttribute('data-search-url') || '/search';
      var url = base + '/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url).then(function(r){ return r.json(); }).then(function(d){
        var items = (d.resources && d.resources.results && d.resources.results.products) || [];
        if(!items.length){ box.innerHTML = '<div class="hdr__pred-empty">Sin resultados para "' + escapeHtml(q) + '"</div>'; box.hidden = false; return; }
        var html = '';
        items.forEach(function(p){
          var img = p.image || (p.featured_image && p.featured_image.url) || '';
          html += '<a class="hdr__pred-item" href="' + p.url + '">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '<span class="hdr__pred-noimg"></span>') + '<span class="hdr__pred-title">' + escapeHtml(p.title) + '</span></a>';
        });
        box.innerHTML = html; box.hidden = false;
      }).catch(function(){ box.hidden = true; });
    }, 220);
  }
  document.addEventListener('input', function(e){ if(e.target && e.target.matches && e.target.matches('[data-hdr-input]')) onInput(e.target); });
  document.addEventListener('click', function(e){
    var burger = e.target.closest && e.target.closest('[data-hdr-burger]');
    if(burger){ var hdr = burger.closest('.hdr'); var m = hdr && hdr.querySelector('[data-hdr-mobile]'); if(m){ var open = m.classList.toggle('is-open'); burger.setAttribute('aria-expanded', open ? 'true':'false'); } return; }
    var mt = e.target.closest && e.target.closest('[data-hdr-mtoggle]');
    if(mt){ mt.parentElement.classList.toggle('is-open'); return; }
    if(!(e.target.closest && e.target.closest('[data-hdr-search]'))){ document.querySelectorAll('[data-hdr-results]').forEach(function(b){ b.hidden = true; }); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ProductCards"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSeccion(seccion) {
    var sid  = seccion.dataset.sectionId;
    var grid = document.getElementById('ld-grid-' + sid);
    if (!grid) return;

    var tarjetas     = Array.from(grid.querySelectorAll('.ld-productos__tarjeta'));
    var dropdowns    = Array.from(seccion.querySelectorAll('[data-dropdown]'));

    // Separar pills por tipo para evitar cruces
    var pillsJugador = Array.from(seccion.querySelectorAll('[data-filtro-jugador]'));
    var pillsEquipo  = Array.from(seccion.querySelectorAll('[data-filtro-equipo]'));

    var inputMin     = seccion.querySelector('[data-price="min"]');
    var inputMax     = seccion.querySelector('[data-price="max"]');
    var jugadorLabel = seccion.querySelector('[data-jugador-label]');
    var equipoLabel  = seccion.querySelector('[data-equipo-label]');
    var precioLabel  = seccion.querySelector('[data-precio-label]');

    var filtroJugador = 'todos';
    var filtroEquipo  = 'todos';
    var precioMin = inputMin ? parseFloat(inputMin.value) : 0;
    var precioMax = inputMax ? parseFloat(inputMax.value) : 15000;

    // ---- Dropdowns: cerrar al abrir otro (solo dentro de esta sección) ----
    dropdowns.forEach(function (dd) {
      dd.addEventListener('toggle', function () {
        if (dd.open) {
          dropdowns.forEach(function (other) {
            if (other !== dd) other.removeAttribute('open');
          });
        }
      });
    });

    // ---- Cerrar al hacer click fuera de esta sección ----
    document.addEventListener('click', function (e) {
      if (!seccion.contains(e.target)) {
        dropdowns.forEach(function (dd) { dd.removeAttribute('open'); });
      }
    });

    // ---- Filtrado ----
    function aplicar() {
      tarjetas.forEach(function (t) {
        var jugador = t.dataset.jugador || '';
        var equipo  = t.dataset.equipo  || '';
        var precio  = parseFloat(t.dataset.precio) || 0;
        var pasaJugador = filtroJugador === 'todos' || jugador === filtroJugador;
        var pasaEquipo  = filtroEquipo  === 'todos' || equipo  === filtroEquipo;
        var pasaPrecio  = precio >= precioMin && precio <= precioMax;
        t.style.display = (pasaJugador && pasaEquipo && pasaPrecio) ? '' : 'none';
      });
      // Actualizar estado activo de cada grupo por separado
      pillsJugador.forEach(function (p) {
        p.classList.toggle('ld-productos__pill--activa', p.dataset.filtroJugador === filtroJugador);
      });
      pillsEquipo.forEach(function (p) {
        p.classList.toggle('ld-productos__pill--activa', p.dataset.filtroEquipo === filtroEquipo);
      });
    }

    function actualizarLabelPrecio() {
      if (!precioLabel) return;
      precioLabel.textContent = '$' + (inputMin ? inputMin.value : precioMin) + ' – $' + (inputMax ? inputMax.value : precioMax);
    }

    // ---- Listeners: jugador ----
    pillsJugador.forEach(function (pill) {
      pill.addEventListener('click', function () {
        filtroJugador = this.dataset.filtroJugador;          // solo lee su propio atributo
        if (jugadorLabel) jugadorLabel.textContent = this.textContent;
        var dd = this.closest('[data-dropdown]');
        if (dd) dd.removeAttribute('open');
        aplicar();
      });
    });

    // ---- Listeners: equipo ----
    pillsEquipo.forEach(function (pill) {
      pill.addEventListener('click', function () {
        filtroEquipo = this.dataset.filtroEquipo;            // solo lee su propio atributo
        if (equipoLabel) equipoLabel.textContent = this.textContent;
        var dd = this.closest('[data-dropdown]');
        if (dd) dd.removeAttribute('open');
        aplicar();
      });
    });

    // ---- Listeners: precio ----
    function actualizarPrecio() {
      var a = parseFloat(inputMin ? inputMin.value : 0) || 0;
      var b = parseFloat(inputMax ? inputMax.value : 15000) || 15000;
      precioMin = Math.min(a, b);
      precioMax = Math.max(a, b);
      actualizarLabelPrecio();
      aplicar();
    }
    if (inputMin) inputMin.addEventListener('input', actualizarPrecio);
    if (inputMax) inputMax.addEventListener('input', actualizarPrecio);

    // ---- Estado inicial ----
    actualizarLabelPrecio();
    aplicar();
  }

  function init() {
    document.querySelectorAll('[data-section-id]').forEach(initSeccion);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ProductCardsChampions"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSeccion(seccion) {
    var sid  = seccion.dataset.championsSection;
    var grid = document.getElementById('ldc-grid-' + sid);
    if (!grid) return;

    var tarjetas     = Array.from(grid.querySelectorAll('.ld-productos__tarjeta'));
    var dropdowns    = Array.from(seccion.querySelectorAll('[data-dropdown]'));

    // Separar pills por tipo para evitar cruces
    var pillsJugador = Array.from(seccion.querySelectorAll('[data-filtro-jugador]'));
    var pillsEquipo  = Array.from(seccion.querySelectorAll('[data-champions-equipo]'));

    var inputMin     = seccion.querySelector('[data-price="min"]');
    var inputMax     = seccion.querySelector('[data-price="max"]');
    var jugadorLabel = seccion.querySelector('[data-jugador-label]');
    var equipoLabel  = seccion.querySelector('[data-equipo-label]');
    var precioLabel  = seccion.querySelector('[data-precio-label]');

    var filtroJugador = 'todos';
    // Arranca con el primer equipo de la colección activo
    var filtroEquipo  = pillsEquipo.length ? pillsEquipo[0].dataset.championsEquipo : 'todos';
    var precioMin = inputMin ? parseFloat(inputMin.value) : 0;
    var precioMax = inputMax ? parseFloat(inputMax.value) : 9999999;

    // ---- Dropdowns: cerrar al abrir otro (solo dentro de esta sección) ----
    dropdowns.forEach(function (dd) {
      dd.addEventListener('toggle', function () {
        if (dd.open) {
          dropdowns.forEach(function (other) {
            if (other !== dd) other.removeAttribute('open');
          });
        }
      });
    });

    // ---- Cerrar al hacer click fuera de esta sección ----
    document.addEventListener('click', function (e) {
      if (!seccion.contains(e.target)) {
        dropdowns.forEach(function (dd) { dd.removeAttribute('open'); });
      }
    });

    // ---- Filtrado ----
    function aplicar() {
      tarjetas.forEach(function (t) {
        var jugador = t.dataset.jugador || '';
        var equipo  = t.dataset.equipo  || '';
        var precio  = parseFloat(t.dataset.precio) || 0;
        var pasaJugador = filtroJugador === 'todos' || jugador === filtroJugador;
        var pasaEquipo  = filtroEquipo  === 'todos' || equipo  === filtroEquipo;
        var pasaPrecio  = precio >= precioMin && precio <= precioMax;
        t.style.display = (pasaJugador && pasaEquipo && pasaPrecio) ? '' : 'none';
      });
      // Actualizar estado activo de cada grupo por separado
      pillsJugador.forEach(function (p) {
        p.classList.toggle('ld-productos__pill--activa', p.dataset.filtroJugador === filtroJugador);
      });
      pillsEquipo.forEach(function (p) {
        p.classList.toggle('ld-productos__pill--activa', p.dataset.championsEquipo === filtroEquipo);
      });
    }

    function actualizarLabelPrecio() {
      if (!precioLabel) return;
      precioLabel.textContent = '$' + (inputMin ? inputMin.value : precioMin) + ' – $' + (inputMax ? inputMax.value : precioMax);
    }

    // ---- Listeners: jugador ----
    pillsJugador.forEach(function (pill) {
      pill.addEventListener('click', function () {
        filtroJugador = this.dataset.filtroJugador;          // solo lee su propio atributo
        if (jugadorLabel) jugadorLabel.textContent = this.textContent;
        var dd = this.closest('[data-dropdown]');
        if (dd) dd.removeAttribute('open');
        aplicar();
      });
    });

    // ---- Listeners: equipo ----
    pillsEquipo.forEach(function (pill) {
      pill.addEventListener('click', function () {
        filtroEquipo = this.dataset.championsEquipo;         // solo lee su propio atributo
        if (equipoLabel) equipoLabel.textContent = this.textContent;
        var dd = this.closest('[data-dropdown]');
        if (dd) dd.removeAttribute('open');
        aplicar();
      });
    });

    // ---- Listeners: precio ----
    function actualizarPrecio() {
      var a = parseFloat(inputMin ? inputMin.value : 0) || 0;
      var b = parseFloat(inputMax ? inputMax.value : 9999999) || 9999999;
      precioMin = Math.min(a, b);
      precioMax = Math.max(a, b);
      actualizarLabelPrecio();
      aplicar();
    }
    if (inputMin) inputMin.addEventListener('input', actualizarPrecio);
    if (inputMax) inputMax.addEventListener('input', actualizarPrecio);

    // ---- Estado inicial ----
    actualizarLabelPrecio();
    aplicar();
  }

  function init() {
    document.querySelectorAll('[data-champions-section]').forEach(initSeccion);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ProductCardsNFL"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSeccion(seccion) {
    var sid  = seccion.dataset.sectionId;
    var grid = document.getElementById('ld-grid-' + sid);
    if (!grid) return;

    var tarjetas     = Array.from(grid.querySelectorAll('.ld-productos__tarjeta'));
    var dropdowns    = Array.from(seccion.querySelectorAll('[data-dropdown]'));

    // Separar pills por tipo para evitar cruces
    var pillsJugador = Array.from(seccion.querySelectorAll('[data-filtro-jugador]'));
    var pillsEquipo  = Array.from(seccion.querySelectorAll('[data-filtro-equipo]'));

    var inputMin     = seccion.querySelector('[data-price="min"]');
    var inputMax     = seccion.querySelector('[data-price="max"]');
    var jugadorLabel = seccion.querySelector('[data-jugador-label]');
    var equipoLabel  = seccion.querySelector('[data-equipo-label]');
    var precioLabel  = seccion.querySelector('[data-precio-label]');

    var filtroJugador = 'todos';
    var filtroEquipo  = 'san-francisco-49ers';
    var precioMin = inputMin ? parseFloat(inputMin.value) : 0;
    var precioMax = inputMax ? parseFloat(inputMax.value) : 9999999;

    // ---- Dropdowns: cerrar al abrir otro (solo dentro de esta sección) ----
    dropdowns.forEach(function (dd) {
      dd.addEventListener('toggle', function () {
        if (dd.open) {
          dropdowns.forEach(function (other) {
            if (other !== dd) other.removeAttribute('open');
          });
        }
      });
    });

    // ---- Cerrar al hacer click fuera de esta sección ----
    document.addEventListener('click', function (e) {
      if (!seccion.contains(e.target)) {
        dropdowns.forEach(function (dd) { dd.removeAttribute('open'); });
      }
    });

    // ---- Filtrado ----
    function aplicar() {
      tarjetas.forEach(function (t) {
        var jugador = t.dataset.jugador || '';
        var equipo  = t.dataset.equipo  || '';
        var precio  = parseFloat(t.dataset.precio) || 0;
        var pasaJugador = filtroJugador === 'todos' || jugador === filtroJugador;
        var pasaEquipo  = filtroEquipo  === 'todos' || equipo  === filtroEquipo;
        var pasaPrecio  = precio >= precioMin && precio <= precioMax;
        t.style.display = (pasaJugador && pasaEquipo && pasaPrecio) ? '' : 'none';
      });
      // Actualizar estado activo de cada grupo por separado
      pillsJugador.forEach(function (p) {
        p.classList.toggle('ld-productos__pill--activa', p.dataset.filtroJugador === filtroJugador);
      });
      pillsEquipo.forEach(function (p) {
        p.classList.toggle('ld-productos__pill--activa', p.dataset.filtroEquipo === filtroEquipo);
      });
    }

    function actualizarLabelPrecio() {
      if (!precioLabel) return;
      precioLabel.textContent = '$' + (inputMin ? inputMin.value : precioMin) + ' – $' + (inputMax ? inputMax.value : precioMax);
    }

    // ---- Listeners: jugador ----
    pillsJugador.forEach(function (pill) {
      pill.addEventListener('click', function () {
        filtroJugador = this.dataset.filtroJugador;          // solo lee su propio atributo
        if (jugadorLabel) jugadorLabel.textContent = this.textContent;
        var dd = this.closest('[data-dropdown]');
        if (dd) dd.removeAttribute('open');
        aplicar();
      });
    });

    // ---- Listeners: equipo ----
    pillsEquipo.forEach(function (pill) {
      pill.addEventListener('click', function () {
        filtroEquipo = this.dataset.filtroEquipo;            // solo lee su propio atributo
        if (equipoLabel) equipoLabel.textContent = this.textContent;
        var dd = this.closest('[data-dropdown]');
        if (dd) dd.removeAttribute('open');
        aplicar();
      });
    });

    // ---- Listeners: precio ----
    function actualizarPrecio() {
      var a = parseFloat(inputMin ? inputMin.value : 0) || 0;
      var b = parseFloat(inputMax ? inputMax.value : 9999999) || 9999999;
      precioMin = Math.min(a, b);
      precioMax = Math.max(a, b);
      actualizarLabelPrecio();
      aplicar();
    }
    if (inputMin) inputMin.addEventListener('input', actualizarPrecio);
    if (inputMax) inputMax.addEventListener('input', actualizarPrecio);

    // ---- Estado inicial ----
    actualizarLabelPrecio();
    aplicar();
  }

  function init() {
    document.querySelectorAll('[data-section-id]').forEach(initSeccion);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
